import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Masters from '../views/Masters.vue'
import MasterDetail from '../views/MasterDetail.vue'
import News from '../views/News.vue'
import NewsDetail from '../views/NewsDetail.vue'  // 新增的资讯详情页组件
import Gallery from '../views/Gallery.vue'
import Certificate from '../views/Certificate.vue'
import About from '../views/About.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '首页'
    }
  },
  {
    path: '/masters',
    name: 'Masters',
    component: Masters,
    meta: {
      title: '大师名录'
    }
  },
  {
    path: '/masters/:id',
    name: 'MasterDetail',
    component: MasterDetail,
    props: true,
    meta: {
      title: '匠人详情'
    }
  },
  {
    path: '/news',
    name: 'News',
    component: News,
    meta: {
      title: '馆藏资讯'
    }
  },
  {
    path: '/news/:id',
    name: 'NewsDetail',
    component: NewsDetail,
    props: true,
    meta: {
      title: '资讯详情'
    }
  },
  {
    path: '/gallery',
    name: 'Gallery',
    component: Gallery,
    meta: {
      title: '作品展示'
    }
  },
  {
    path: '/certificate',
    name: 'Certificate',
    component: Certificate,
    meta: {
      title: '证书查询'
    }
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: {
      title: '平台介绍'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// 全局路由守卫 - 设置页面标题
router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? `${to.meta.title} - 中国玉雕大师收藏网` : '中国玉雕大师收藏网'
  next()
})

export default router
